import { FilterBar } from '@/components/ui/FilterBar';
import { getRoleLabel, ROLE_LABELS } from '@/lib/roles';
import * as React from 'react';

const ROLE_OPTIONS = [
  { value: '', label: 'All Roles' },
  ...Object.entries(ROLE_LABELS).map(([value, label]) => ({ value, label })),
];

const ENABLED_OPTIONS = [
  { value: '', label: 'All' },
  { value: 'true', label: 'Enabled' },
  { value: 'false', label: 'Disabled' },
];

export interface UsersFiltersProps {
  searchTerm: string;
  selectedRole: string;
  selectedEnabled: string;
  onSearchChange: (value: string) => void;
  onRoleChange: (value: string) => void;
  onEnabledChange: (value: string) => void;
  onClearFilters: () => void;
}

export const UsersFilters: React.FC<UsersFiltersProps> = ({
  searchTerm,
  selectedRole,
  selectedEnabled,
  onSearchChange,
  onRoleChange,
  onEnabledChange,
  onClearFilters,
}) => {
  return (
    <FilterBar
      searchPlaceholder='Search users by name, email...'
      searchValue={searchTerm}
      onSearchChange={onSearchChange}
      filters={[
        { key: 'role', label: 'Role', options: ROLE_OPTIONS },
        { key: 'enabled', label: 'Enabled', options: ENABLED_OPTIONS },
      ]}
      filterValues={{ role: selectedRole, enabled: selectedEnabled }}
      onFilterChange={(key, value) => {
        if (key === 'role') onRoleChange(value);
        if (key === 'enabled') onEnabledChange(value);
      }}
      onClearAll={onClearFilters}
      activeFilters={[
        { label: 'Search', value: searchTerm, color: 'blue' },
        {
          label: 'Role',
          value: selectedRole ? getRoleLabel(selectedRole) : '',
          color: 'green',
        },
        {
          label: 'Enabled',
          value: selectedEnabled
            ? selectedEnabled === 'true'
              ? 'Yes'
              : 'No'
            : '',
          color: 'yellow',
        },
      ]}
    />
  );
};
